import React from 'react';
import { useHistory } from 'react-router-dom';
import SkeletonLoader from 'src/components/SkeletonLoader';

type Props = {};

export default function Loading({}: Props) {
  const history = useHistory();

  return (
    <>
      <div className="d-flex align-items-center">
        <SkeletonLoader className="h-100px w-100px" contentClassName="w-100px h-100px" />
        <div className="mx-10">
          <SkeletonLoader className="w-100" contentClassName="w-25" />
          <div className="d-flex ">
            <SkeletonLoader className="w-75px mt-5" contentClassName="w-100 h-25px" />
            <SkeletonLoader className="w-75px mt-5 mx-5 text-gray-100" contentClassName="w-100 h-25px" />
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-8 mb-5 ">
          <div className="row bg-white p-5 h-100 align-items-center">
            <div className="col-md-8 mb-5">
              <SkeletonLoader className="mb-3 w-100" contentClassName="w-25" />
              <SkeletonLoader className="position-relative w-100" contentClassName="h-250px" />
            </div>
            <div className="col-md-4 mb-1">
              <SkeletonLoader className="mb-3 w-50" />
              <div className="mb-10">
                <div className="d-flex align-items-center mb-1">
                  <SkeletonLoader className="w-25" />
                </div>
                <div className="d-flex align-items-center">
                  <SkeletonLoader className="w-50" />
                </div>
              </div>
              <SkeletonLoader className="mb-3 w-50" />
              <div className="mb-10">
                <div className="d-flex align-items-center mb-1">
                  <SkeletonLoader className="w-25" />
                </div>
                <div className="d-flex align-items-center">
                  <SkeletonLoader className="w-50" />
                </div>
              </div>
              <SkeletonLoader className="mb-3 w-50" />
              <div className="mb-0">
                <div className="d-flex align-items-center mb-1">
                  <SkeletonLoader className="w-25" />
                </div>
                <div className="d-flex align-items-center">
                  <SkeletonLoader className="w-50" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 ps-md-10 mb-5">
          <div className="row bg-white px-5 pt-2 h-100 ">
            <div className="d-flex align-items-center justify-content-between mb-5">
              <div className="fs-5 fw-semibold text-gray-900  d-flex align-items-center">
                <SkeletonLoader className=" w-100" contentClassName="w-100px" />
                <span className="mx-2 ">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="d-flex w-100 mb-3 mb-sm-0 jusitfy-content-between cursor-pointer">
              <div>
                <div className="position-relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-mail"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
              </div>
              <div className="mx-7 ">
                <SkeletonLoader className="w-200px" />
              </div>
            </div>

            <div className="d-flex w-100 mb-3 mb-sm-0 cursor-pointer">
              <div className="position-relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-mail"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div className="mx-7">
                <SkeletonLoader className="w-200px" />
              </div>
            </div>
            <div className="d-flex w-100 mb-3 mb-sm-0 cursor-pointer">
              <div>
                <div className="position-relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                </div>
                <div className="text-center mt-1"></div>
              </div>
              <div className="mx-7">
                <SkeletonLoader className="w-200px" />
              </div>
            </div>
            <div className="d-flex w-100 mb-2 cursor-pointer">
              <div className="position-relative">
                <div>
                  <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="css-i6dzq1"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
              </div>
              <div className="mx-7">
                <SkeletonLoader className="w-200px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-8 mb-5">
          <div className="row h-100">
            <div className="col-md-4 mb-5">
              <div className="row bg-white h-100 p-5 mb-5">
                <div className="fs-5 fw-semibold text-gray-900 mb-5">Sipariş Aksiyonlarım</div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Yeni Siparişler</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Geciken Siparişler</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Bekleyen İadeler</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Sipariş Soruları</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
              </div>
            </div>
            <div className="col-md-4 ps-md-10 mb-5">
              <div className="row bg-white h-100 p-5">
                <div className="fs-5 fw-semibold text-gray-900 mb-5">Ürün Aksiyonlarım</div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Eksik Bilgili Ürünler</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Stoğu Olmayan Ürünler</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Stoğu Azalan Ürünler</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>Ürün Soruları</div>
                  <SkeletonLoader className=" w-25" contentClassName="w-100px" />
                </div>
              </div>
            </div>
            <div className="col-md-4 ps-md-10  mb-5">
              <div className="row bg-white h-100 p-5">
                <div className="fs-5 fw-semibold text-gray-900 mb-5">Fatura Aksiyonları</div>
                <div className="d-flex align-items-center justify-content-center ">
                  <div className="justify-content-center align-items-center d-flex flex-column">
                    <div className="badge badge-light-primary p-8 mb-5 fs-1">
                      <SkeletonLoader className="badge" />
                    </div>
                    <div>Platforma Bildirilmemiş Fatura</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 ps-md-10 mb-5">
          <div className="row bg-white p-5 mb-5">
            <div className="d-flex align-items-center justify-content-between mb-5">
              <div className="fs-5 fw-semibold text-gray-900  d-flex align-items-center">Muhasebe</div>
              <div className="text-gray-600 text-decoration-underline fs-7 cursor-pointer" onClick={() => history.push('/finance/vesting')}>
                Detayları Gör
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 ">
                <div className="mb-5">
                  <div>Son Ödenen Hak Ediş</div>
                  <SkeletonLoader className="w-100" contentClassName="w-100px" />
                </div>
                <div className="mb-5">
                  <div>Gelecek Ödemeler</div>
                  <div className="fw-bolder mb-15">
                    <SkeletonLoader className="w-25" contentClassName="w-100px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 bg-white p-5">
          <div className="fs-5 fw-semibold text-gray-900 mb-3">Çok Satanlar</div>
          <div className="d-lg-flex align-items-center overflow-auto ">
            <div className="d-lg-flex flex-nowrap mb-5">
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
              <div className="card w-lg-200px me-5 mb-5">
                <SkeletonLoader className="rounded h-200px position-relative" contentClassName="w-100 h-200px" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-75" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-50" />
                <SkeletonLoader className="mt-3 w-100" contentClassName="w-25" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-6 mb-5 ">
          <div className="row bg-white p-5 h-100 align-items-center">
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead>
                    <tr className="fw-semibold fs-5 text-gray-900">
                      <th className="min-w-300px">Çok Satan Markalar</th>
                      <th className="">Adet</th>
                      <th className="min-w-125px">Tutar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-25" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-100" contentClassName="w-50" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-50" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-25" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-100" contentClassName="w-50" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-50" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-25" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-100" contentClassName="w-50" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-50" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="separator separator-dashed my-5"></div>
            <div className="table-responsive">
              <div className="col-md-12">
                <table className="table align-middle">
                  <thead>
                    <tr className="fw-semibold fs-5 text-gray-900">
                      <th className="min-w-300px">Çok Satan Kategoriler</th>
                      <th className="">Adet</th>
                      <th className="min-w-125px">Tutar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-25" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-100" contentClassName="w-50" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-50" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-25" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-100" contentClassName="w-50" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-50" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-25" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-100" contentClassName="w-50" />
                      </td>
                      <td>
                        <SkeletonLoader className="w-50" contentClassName="w-50" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 ps-md-10 mb-5">
          <div className="row bg-white p-5 h-100 ">
            <div className="d-flex justify-content-between mb-5">
              <SkeletonLoader className="w-50" contentClassName="w-25" />

              <div className="text-gray-600 text-decoration-underline fs-7">İptal Raporuna Git</div>
            </div>
            <SkeletonLoader className="w-100 h-full" contentClassName="w-100 h-300px" />
          </div>
        </div>
      </div>
    </>
  );
}
